module.exports = __webpack_public_path__ + "img/baseline-cast_for_education-48px.1c8724af.svg";